import React, { Component, Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';

import './CadeResource.css';

class CadeResourceModal extends Component {


    /*
    * CadeResourceModel provides a modal window for each resource type. It works in conjunction with CadeResourceIcons that provides an iconic interface for the resources.
    * CadeResourceModal is passed information about the resource to display (type, name, etc.) and then displays a bootstrap modal with the resource as content.
    * There is one modal for each type of resource and they will self select based upon the passed in props.
    * 
    * Note:  The caller is responsible for closing the modal window by setting resType=0 state.
    * Note2:  pdf files from an https site don't work using:  <a className="cadeResource_Anchor" href={this.props.resUri} target="_blank" rel="noreferrer noopener">Click here to open this document in a new browser tab</a>
    */

    render() {
        let pdf = "https://files.clear-cade.com" + this.props.resUri;
        let webm = "https://files.clear-cade.com" + this.props.resUri;
        return (
            <Fragment>
                <Modal
                    show={this.props.resType == 2}
                    onHide={this.props.modalCloseHandler}>

                    <Modal.Header closeButton>
                        <Modal.Title>CADE {this.props.domainName} Image Resource</Modal.Title>
                    </Modal.Header>
                    
                    <Modal.Body>
                        <img className="cadeResource_Image" src={this.props.resUri} alt="CADE Resource" />
                        <h4>{this.props.resName}</h4>
                        <span dangerouslySetInnerHTML={{ __html: this.props.resDesc }}></span>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={this.props.resType == 1}
                    onHide={this.props.modalCloseHandler}>

                    <Modal.Header closeButton>
                        <Modal.Title>CADE {this.props.domainName} Document Resource</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <a className="cadeResource_Anchor" href={pdf} target="_blank" rel="noreferrer noopener">Click here to open this document in a new browser tab</a>
                        <h4>{this.props.resName}</h4>
                        <p>{this.props.resDesc}</p>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={this.props.resType == 3}
                    onHide={this.props.modalCloseHandler}>

                    <Modal.Header closeButton>
                        <Modal.Title>CADE {this.props.domainName} Audio Resource</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <audio controls>
                            <source src={this.props.resUri} type="audio/mpeg" />
                            Your browser does not support audio controls.
                        </audio>
                        <h4>{this.props.resName}</h4>
                        <p>{this.props.resDesc}</p>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={this.props.resType == 4}
                    onHide={this.props.modalCloseHandler}>

                    <Modal.Header closeButton>
                        <Modal.Title>CADE {this.props.domainName} Video Resource</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <video className="cadeResource_Image" width="400" height="320" controls>
                            <source src={webm} type="video/mp4" />
                            Your browser does not support video controls.
                        </video>
                        <h4>{this.props.resName}</h4>
                        <p>{this.props.resDesc}</p>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={this.props.resType == 5}
                    onHide={this.props.modalCloseHandler}>

                    <Modal.Header closeButton>
                        <Modal.Title>CADE {this.props.domainName} Website Resource</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <a className="cadeResource_Anchor" href={this.props.resUri} target="_blank">Click here to display this information in a new browser tab</a>
                        <h4>{this.props.resName}</h4>
                        <p>{this.props.resDesc}</p>
                    </Modal.Body>
                </Modal>
            </Fragment>
        );
    }
}

export default CadeResourceModal;


// WEBPACK FOOTER //
// ./src/components/CadeResource/CadeResourceModal.js